import { combineReducers } from 'redux';
import breadCrumbs from './breadCrumbsReducer';
import catalogs from './catalogReducer';
import contact from './ContactUsReducers';
import faqs from './faqReducer';
import getContext from './getContextReducer';
import incidents from './incidentReducer';
import issueFaq from './issueFaqReducer';
import nonOrderIssue from './nonOrderIssueReducer';
import orderIssue from './orderIssueReducer';
import orderList from 'fk-cp-common-components/reducers/orderListReducer';
import search from './searchReducer';
import selectedCatalog from './selectedCatalogReducer';
import serviceTickets from './serviceTicketReducer';
import subCatalog from './subCatalogsReducer';
import suggestion from './suggestionReducer';
import viewType from './viewTypeReducer';
export default combineReducers({
    breadCrumbs,
    catalogs,
    contact,
    faqs,
    getContext,
    incidents,
    issueFaq,
    nonOrderIssue,
    orderIssue,
    orderList,
    search,
    selectedCatalog,
    serviceTickets,
    subCatalog,
    suggestion,
    viewType
});
